import React, { useContext } from 'react';
import { Form } from 'react-bootstrap';
import { sortBy } from 'lodash';

import AppContext from '../contexts/app-context';

function PortfolioSelect({ isLoading }) {
  const { setActivePortfolio, userPortfolios, userSelectedPortfolio } =
    useContext(AppContext);

  const isMultiplePorfolios = () => {
    if (!userPortfolios) return false;
    if (userPortfolios.length > 0) return true;
  };

  return isMultiplePorfolios(userPortfolios) ? (
    <Form
      inline
      style={{
        display: 'inline-block',
        marginRight: '1em',
        marginBottom: '0.5em',
      }}
    >
      <Form.Group controlId='PortfolioSelect'>
        <Form.Label style={{ display: 'block', marginRight: '.5rem' }}>
          Portfolio:
        </Form.Label>
        <Form.Control
          as='select'
          size='sm'
          disabled={isLoading}
          onChange={(e) => setActivePortfolio({ id: parseInt(e.target.value) })}
          value={userSelectedPortfolio.id}
          data-id='page-head_port'
        >
          <option key={-1} value={-1}>
            {'My Organizations'}
          </option>
          {sortBy(userPortfolios, ['name']).map((item) => (
            <option key={item.id} value={item.id}>
              {item.name}
            </option>
          ))}
        </Form.Control>
      </Form.Group>
    </Form>
  ) : (
    <></>
  );
}

export default PortfolioSelect;
